import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Auth, signInWithEmailAndPassword } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ERROR_SNACKBAR_CONFIG } from '../../constants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    CommonModule,
  ],
})
export class LoginComponent {
  loginForm: FormGroup;

  private _snackBar = inject(MatSnackBar);

  constructor(
    private fb: FormBuilder,
    private _auth: Auth,
    private _router: Router
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.login(
        this.loginForm.get('email')!.value,
        this.loginForm.get('password')!.value
      );
    }
  }

  login(email: string, password: string) {
    signInWithEmailAndPassword(this._auth, email, password)
      .then(() => {
        this._router.navigate(['/admin']);
      })
      .catch((err) => {
        console.error('Login error', err);
        this._snackBar.open(
          'Erreur de connexion. Veuillez vérifier que vos identifiants sont les bons. Si le problème persiste, contactez le support.',
          'Fermer',
          ERROR_SNACKBAR_CONFIG
        );
      });
  }
}
